import { useEffect, useState } from "react";
import Header from "./Header";
import Footer from "./Footer";
import ContactWidget from "./WhatsAppButton";
import AIAssistant from "./AIAssistant";
import EnquiryDialog from "./EnquiryDialog";
import { Toaster } from "./ui/sonner";

/**
 * PageShell — shared layout for inner pages.
 * Uses the SAME main Header (logo + hamburger menu + Premium CBSE tagline)
 * as the home page so navigation is consistent across the entire site.
 */
export default function PageShell({ children }) {
  const [enquireOpen, setEnquireOpen] = useState(false);
  const openEnquire = () => setEnquireOpen(true);
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="bg-white">
      <Header onEnquire={openEnquire} />

      <main>
        {typeof children === "function" ? children({ openEnquire }) : children}
      </main>

      <Footer onEnquire={openEnquire} />
      <ContactWidget />
      <AIAssistant />
      <EnquiryDialog open={enquireOpen} onOpenChange={setEnquireOpen} />
      <Toaster position="top-center" />
    </div>
  );
}
